import InfoWindowView from './InfoWindowView';
import $ from 'jquery';

import template from 'ofs/templates/unit-detail';


export default class UnitInfoWindowView extends InfoWindowView {
  get template() {
    return template;
  }

  get className() {
    return 'ofs-infowindow ofs-unit-infowindow';
  }

  get overlayOptions() {
    return Object.assign(super.overlayOptions, {
      offset: new google.maps.Size(0, -35)
    });
  }

  renderTemplate() {
    super.renderTemplate(arguments);
    var color = '#333';
    this.$el.find('.ofs-infowindow-footer').css('background-color', color);
    this.$el.find('.ofs-infowindow-arrow span').css('border-top-color', color);
  }
}


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/backbone/views/geo/UnitInfoWindowView.js
 **/